import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
export function ClosingSection() {
  return <section className="section wash closing" aria-labelledby="closing-heading" data-id="element-23" data-mp="ounb6xmzo6p8">
      <div className="shell" data-id="element-24" data-mp="12twtc2ur9avu">
        <p className="eyebrow" data-id="element-25" data-mp="12qr0ccj09ouu">YOUR NEXT SESSION</p>
        <h2 id="closing-heading" data-id="element-26" data-mp="xthdn4n03rap">
          Your next training sessions.
          <br data-id="element-27" data-mp="1cr1bzspe6o7w" />
          <span data-id="element-28" data-mp="1cqhu2bzqrztv">Already planned for you.</span>
        </h2>
        <p data-id="element-29" data-mp="1cox0opp5ymxl">
          Volume 1: five workshops with facilitator wording, realistic cases and observation sheets — so your
          preparation is reading and printing, not writing from scratch.
        </p>
        <CtaButton href="#offer-details" data-id="element-30" data-mp="1ll5zc25bhhio">
          See the complete plan — $27 <ArrowRightIcon size={19} aria-hidden="true" data-id="element-31" data-mp="1hi9oixm0qppa" />
        </CtaButton>
        <p className="cta-note" data-id="element-32" data-mp="1vikhq7aswgdm">USD · One-time payment · English-language PDFs</p>
      </div>
    </section>;
}